import { combineReducers } from 'redux';
import * as types from '../actions/ActionTypes';
import WordingService from '../services/WordingService';

const initialState = {
  postalCodeError: {
    valid: true,
    errorMessage: '',
  },
  isFetching: false,
  letterIsSent: false,
};

/**
 * Object input error
 * @param state
 * @param action
 * @return {*}
 */
export const postalCodeError = (state = initialState.postalCodeError, action) => {
  switch (action.type) {
    case types.CLEAR_POSTAL_CODE_ERROR:
      return initialState.postalCodeError;
    case types.SET_POSTAL_CODE_ERROR:
      switch (action.payload.errorType) {
        case 'empty':
          return {
            valid: false,
            errorMessage: WordingService.getWording('errorMessage', 'noPostalCode'),
          };
        case 'incorrect':
          return {
            valid: false,
            errorMessage: WordingService.getWording('errorMessage', 'postalCodeIsIncorrect'),
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

/**
 * Boolean if the letter was successfully sent to the user
 * @param state
 * @param action
 * @return {boolean}
 */
export function letterIsSent(state = initialState.letterIsSent, action) {
  switch (action.type) {
    case types.SEND_LETTER_SUCCESS:
      return true;
    case types.SEND_LETTER_FAILURE:
      return false;
    default:
      return state;
  }
}

/**
 * Verifies whether the letter stage is currently fetching information
 * @param  {boolean} [state=initialState.isFetching] Whether the state is "fetching" or not
 * @param  {object}  action                          The request action
 * @return {boolean}                                 True if fetching, false otherwise.
 */
export const isFetching = (state = initialState.isFetching, action) => {
  switch (action.type) {
    case types.REQUEST_SENDING_LETTER:
      return true;
    case types.SEND_LETTER_SUCCESS:
    case types.SEND_LETTER_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  isFetching,
  letterIsSent,
  postalCodeError,
});
